import * as Excel from 'exceljs/dist/exceljs';

export class SheetFactory {
  workbook;

  currentWorksheet;

  constructor(title = 'Relatório') {
    this.workbook = new Excel.Workbook();
    this.workbook.creator = 'Leroy Merlin';
    this.currentWorksheet = this.workbook.addWorksheet(title);
  }

  setColumnSizes(sizes) {
    this.currentWorksheet.columns = sizes.map(
      (size) => ({ width: size }),
    );
  }

  setColumnNames(names) {
    this.currentWorksheet.columns = names.map((name, i) => {
      const newColumn = {
        ...this.currentWorksheet.columns[i],
        header: name,
      };

      return newColumn;
    });
  }

  addNewWorkSheet(title) {
    this.currentWorksheet = this.workbook.addWorksheet(title);
  }

  addTitleRow(values) {
    this.addEmptyRow();

    const upperCasedValues = values.map((value) => String(value).toUpperCase());
    const row = this.currentWorksheet.addRow(upperCasedValues);

    row.font = { size: 18, bold: true };
    row.height = 22;
  }

  addSubtitleRow(values) {
    this.addEmptyRow();

    const row = this.currentWorksheet.addRow(values);

    row.font = { size: 17 };
    row.height = 20;
  }

  addEmptyRow() {
    this.currentWorksheet.addRow([]);
  }

  addBoldRow(values) {
    const row = this.currentWorksheet.addRow(values);
    row.font = { bold: true };
  }

  addRows(rows) {
    this.currentWorksheet.addRows(rows);
  }

  async finishSheet() {
    const buffer = await this.workbook.xlsx.writeBuffer();
    return buffer;
  }
}
